import React, { Component } from 'react';
import {
  injectStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
} from 'react-stripe-elements';
import { Link } from 'react-router-dom';

import { history } from '../../state/store';
import { AuthService } from '../../state/auth.service';

import StripeApi from '../../api/stripe';

import { Button } from '../shared/Button';
import { Message } from '../shared/Message';

class PaymentForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      numberError: '',
      expireError: '',
      cvcError: '',
      successMessage: '',
      completeInputs: [],
      isbusy: false,
    };

    this.goBack = this.goBack.bind(this);
    this.catchStripeActivity = this.catchStripeActivity.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  goBack() {
    history.goBack();
  }

  catchStripeActivity(evt, stripeError) {
    const { error } = evt;
    const { completeInputs } = this.state;
    if (error) {
      this.setState({
        [stripeError]: error.message,
      });
    } else {
      this.setState({
        [stripeError]: '',
      });
    }
    if (evt.complete) {
      const newCompletes = Object.assign(completeInputs);

      if (completeInputs.indexOf(evt.elementType) === -1) {
        newCompletes.push(evt.elementType);
      }
      this.setState({
        completeInputs: newCompletes,
      });
    } else {
      if (completeInputs.indexOf(evt.elementType) > -1) {
        const newCompletes = completeInputs.filter(
          comp => comp !== evt.elementType
        );

        this.setState({
          completeInputs: newCompletes,
        });
      }
    }
  }

  async handleSubmit() {
    const user = AuthService.getUser();
    this.setState({ isbusy: true });
    const { source } = await this.props.stripe.createSource({
      type: 'card',
      owner: { email: user.email },
    });
    const newCard = await StripeApi.updateCardInfo(source);
    let cardEnding;
    newCard.data.sources.data.forEach(src => {
      if (src.id === newCard.data.default_source) {
        cardEnding = src.card.last4;
      }
    });
    this.setState({
      successMessage: `Card ****${cardEnding} has been made your default source for payment.`,
      isbusy: false,
    });
    this._element1.clear();
    this._element2.clear();
    this._element3.clear();
  }

  render() {
    const {
      numberError,
      expireError,
      cvcError,
      successMessage,
      completeInputs,
      isbusy,
    } = this.state;
    return (
      <div className="PaymentForm">
        <div className="payment">
          <div className="form__field">
            <label>
              <i className="fa fa-credit-card"></i> Card number
            </label>
            <div className="StripeElement__container">
              <CardNumberElement
                onChange={e => this.catchStripeActivity(e, 'numberError')}
                onReady={c => (this._element1 = c)}
              />
            </div>
            <label>Expiration date</label>
            <div className="StripeElement__container">
              <CardExpiryElement
                onChange={e => this.catchStripeActivity(e, 'expireError')}
                onReady={c => (this._element2 = c)}
              />
            </div>
            <label>CVC</label>
            <div className="StripeElement__container">
              <CardCVCElement
                onChange={e => this.catchStripeActivity(e, 'cvcError')}
                onReady={c => (this._element3 = c)}
              />
            </div>
          </div>
          <div className="form__buttons">
            <Button
              insufficientData={completeInputs.length !== 3}
              type="submit"
              defaultText="Update"
              busyText="Updating"
              isbusy={isbusy}
              onClick={this.handleSubmit}
            />
            <Link to="" onClick={this.goBack}>
              Cancel
            </Link>
          </div>
        </div>
        <div className="validation">
          <Message error={numberError} />
          <Message error={expireError} />
          <Message error={cvcError} />
          <Message success={successMessage} />
        </div>
      </div>
    );
  }
}

export default injectStripe(PaymentForm);



// WEBPACK FOOTER //
// ./src/components/payment/PaymentForm.js